import React from "react";
import bankAccount from "../../@assets/bankAccount.svg";
import debitCard from "../../@assets/debitCard.svg";
import visa from "../../@assets/visa.svg";
import mastercard from "../../@assets/mastercard.svg";
import footerLogo from "../../@assets/footer_logo.svg";
import socialLinks from "../../@assets/Social Links.svg";
import joinBtn from "../../@assets/joinButton.svg";
// import logo from '../../@assets/edflix.svg'
import logo from "../../@assets/logo.svg";
import { FaCheckCircle } from "react-icons/fa";
import getStartedImage from "../../@assets/getStarted.svg";
import homebanner from "../../@assets/HomeBanner.svg";
import mobile from "../../@assets/mobile.svg";
import FXRateComponent from "../../components/Structure/FXRateComponent";
import TypeformButton from "../../components/TypeformButton";
// import SignupModal from "../../components/SignupModal"; // login/signup not needed here
// import SigninModal from "../../components/Structure/Modals/SigninModal";

function UniversityHomePage({ studentId }) {
  // modal state is no longer used; we drive user to Typeform
  // const [showModal, setShowModal] = useState(false);
  // const [signinModal, setSigninModal] = useState(false);

  // const handleLogin = () => {
  //   setSigninModal(true);
  // };

  const handleGetStartedClick = () => {
    // legacy placeholder; TypeformButton handles the actual action
  };

  // Typeform script is injected by TypeformButton component

  return (
    <>
      <div className="d-flex flex-column position-relative">
        <img className="w-100" src="/curvedlines.svg" />

        <div className="d-flex flex-column position-absolute w-100">
          <div className="">
            <nav className="navbar navbar-expand-lg navbar-light py-2 px-3 bg-white">
              <div className="container-fluid">
                <img src={logo} alt="logo" width={250} />
                <div className="d-flex gap-2">
                  {/* <button className='bg-white border-0 text-decoration-underline rounded-3 px-4 py-2 fw-bold opacity-75' style={{ fontSize: '0.9rem', textUnderlineOffset: '10px', }} onClick={handleLogin} >Login</button> */}
                  {/* <button className='bg-white rounded-3 px-4 py-2 fw-bold opacity-75' style={{ fontSize: '0.9rem' }} onClick={handleLogin} >Get Started</button> */}
                  <TypeformButton
                    className="bg-white rounded-3 px-4 py-2 fw-bold opacity-75"
                    style={{ fontSize: "1rem", marginTop: "-20px" }}
                  >
                    Get Started
                  </TypeformButton>
                </div>
              </div>
            </nav>
          </div>

          {/* FIRST COMPONENT */}

          <div className="d-flex justify-content-around mt-4">
            <div className="col-4 d-flex justify-content-center align-items-center position-relative">
              <div
                className=" rounded-4 content-Abhi"
                style={{
                  background: "rgba(255, 255, 255, 0.4)",
                  backdropFilter: "blur(10px)",
                  position: "absolute",
                  top: "10rem",
                  right: "-20rem",
                  padding: "5rem",
                }}
              >
                <h2>Transform Your </h2>
                <h2 style={{ color: "#7F56D9" }}>
                  International Student Experience
                </h2>
                <h5 className="text-secondary opacity-50">
                  Seamless Payments, Instant Banking, Happy Students
                </h5>
                <TypeformButton className="bg-transparent border-0 pt-2" style={{ padding:0 }}>
                  <img src={joinBtn} width={150} alt="btn" />
                </TypeformButton>
              </div>
            </div>

            <div className="">
              <img
                src={homebanner}
                alt="homebanner"
                style={{ width: "45rem" }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* MERGED SECTION */}


      <div className="py-5 mt-5" style={{ background: "#FFF4E3" }}>
        {/* SECOND COMPONENT */}
        <div
          className="rounded-4 py-5 mx-3 "
          style={{ background: "rgba(251, 182, 141, 1)" }}
        >
          <div className="d-flex justify-content-around">
            <div className="d-flex align-items-center">
              <ul className="list-unstyled">
                <li className="border  py-4 rounded-3 mt-3 mb-4 bg-white">
                  <div className="d-flex gap-3 px-3 ">
                    <FaCheckCircle className="my-auto text-success" />
                    <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                      Pre-arrival financial setup
                    </span>
                  </div>
                </li>
                <li className="border  py-4 rounded-3 mt-3 mb-4  bg-white">
                  <div className="d-flex gap-3 px-3">
                    <FaCheckCircle className="my-auto text-success" />
                    <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                      Low-fee international transfers
                    </span>
                  </div>
                </li>
                <li className="border  py-4 rounded-3 mt-3 mb-4  bg-white">
                  <div className="d-flex gap-3 px-3">
                    <FaCheckCircle className="my-auto text-success " />{" "}
                    <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                      Branded, familiar payment experience
                    </span>
                  </div>
                </li>
                <li className="border  py-4 rounded-3 mt-3 mb-4  bg-white">
                  <div className="d-flex gap-3 px-3">
                    <FaCheckCircle className="my-auto text-success" />
                    <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                      Instant fund access upon arrival
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div className="my-3 ">
              <FXRateComponent />
            </div>
          </div>
        </div>

        {/* THIRD COMPONENT */}
        <div className="mt-5  ">
          <div className="text-center my-5">
            <h4>Getting Started is as Easy as 1-2-3:</h4>
          </div>
          <div className="border w-75 rounded-4 py-4 m-auto bg-white">
            <div className="d-flex justify-content-center gap-5">
              <div className="d-flex align-items-center">
                <img src={getStartedImage} width={350} alt="getStarted" />
              </div>
              <div>
                <div className="d-flex align-items-center">
                  <ul className="list-unstyled">
                    <li className="border  py-4 rounded-3 my-3 bg-white">
                      <div className="d-flex gap-3 px-4 ">
                        <div>
                          <div
                            className="text-white px-3 py-2 rounded-5"
                            style={{ background: "#FBB68D" }}
                          >
                            1
                          </div>
                        </div>
                        <div className="fw-bold" style={{ fontSize: "0.9rem" }}>
                          <p className="m-0" style={{ fontSize: "0.8rem" }}>
                            Login and provide university details
                          </p>
                          <p
                            className="m-0 opacity-75"
                            style={{ fontSize: "0.7rem", color: "#FBB68D" }}
                          >
                            {" "}
                            It takes less than 5 minutes!{" "}
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className="border  py-4 rounded-3 my-3 bg-white">
                      <div className="d-flex gap-3 px-4">
                        <div>
                          <div
                            className="text-white px-3 py-2 rounded-5"
                            style={{ background: "#FBB68D" }}
                          >
                            2
                          </div>
                        </div>
                        <div className="fw-bold" style={{ fontSize: "0.9rem" }}>
                          <p className="m-0" style={{ fontSize: "0.75rem" }}>
                            Add your university branding to the payment page{" "}
                          </p>
                          <p
                            className="m-0 opacity-75"
                            style={{ fontSize: "0.7rem", color: "#FBB68D" }}
                          >
                            {" "}
                            In just a few clicks!{" "}
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className="border  py-4 rounded-3 my-3 bg-white">
                      <div className="d-flex gap-3 px-4 ">
                        <div>
                          <div
                            className="text-white px-3 py-2 rounded-5"
                            style={{ background: "#FBB68D" }}
                          >
                            3
                          </div>
                        </div>
                        <div className="fw-bold" style={{ fontSize: "0.9rem" }}>
                          <p className="m-0" style={{ fontSize: "0.75rem" }}>
                            Generate and send payment link to students
                          </p>
                          <p
                            className="m-0 opacity-75"
                            style={{ fontSize: "0.7rem", color: "#FBB68D" }}
                          >
                            It's that simple!{" "}
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOURTH SECTION */}
      <div className="my-5">
        <div className="py-5" style={{ background: "#FCFCFC" }}>
          <div className="text-center pb-5">
            <h4>
              From the moment they accept your offer, your students can enjoy
            </h4>
          </div>
          <div className="d-flex justify-content-around">
            <div>
              <img src={mobile} width={350} alt="mobileImg" />
              <div
                className="text-center pt-3 fw-bold"
                style={{ fontSize: "0.85rem" }}
              >
                <p>Mobile banking app for money management</p>
              </div>
            </div>
            <div>
              <img src={debitCard} width={350} alt="debitCard" />
              <div
                className="text-center pt-3 fw-bold"
                style={{ fontSize: "0.85rem" }}
              >
                <p>A physical debit card</p>
              </div>
            </div>
            <div>
              <img src={bankAccount} width={350} alt="bankAccount" />
              <div
                className="text-center pt-3 fw-bold"
                style={{ fontSize: "0.85rem" }}
              >
                <p>A local bank account in your country</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FIFTH SECTION */}
      <div style={{ paddingBottom: "6rem" }}>
        <div className="text-center">
          <h2>
            Powered by <img src={visa} alt="visa" /> &{" "}
            <img src={mastercard} alt="masterCard" />
          </h2>
          <p>
            Provide students with globally accepted debit cards and secure
            payment options.
          </p>
        </div>
      </div>

      {/* FOOTER */}

      <div
        className="px-5 rounded-top-4 "
        style={{
          background:
            "radial-gradient(39.54% 39.54% at 50% 53.06%, #0A035C 0%, #160F61 28.13%, #09072A 100%",
        }}
      >
        <div className="py-4">
          {/* FIRST ROW */}
          <div className="text-white text-center w-50 m-auto p-5 py-4 ">
            <h4>
              Join Eddflix & harness the power of education to “change the
              world, one payment at a time”
            </h4>
          </div>
          {/* SECOND ROW */}
          <div className="text-center mb-3">
            <button
              className="px-4 py-2 rounded-3 border-0 fw-bold"
              style={{ fontSize: "0.8rem" }}
            >
              Start Changing The World
            </button>
          </div>
          {/* THIRD ROW */}
          <div className="d-flex justify-content-between mt-3x">
            <div>
              <img src={footerLogo} alt="footerLogo" />
            </div>
            <div>
              <img src={socialLinks} alt="socialLinks" />
            </div>
          </div>
          {/* FOURTH ROW */}
          <div className="pt-5">
            <ul
              className="d-flex justify-content-center list-unstyled  gap-5 text-white"
              role="button"
            >
              <li className="">2024 All right reserved.</li>
              <li className="text-decoration-underline">Privacy Policy</li>
              <li className="text-decoration-underline">Terms of Service</li>
              <li className="text-decoration-underline">Cookies Settings</li>
            </ul>
          </div>
        </div>
      </div>
      {/* login/signup modals disabled for this page; users go through Typeform */}
      {/* <SigninModal signinModal={signinModal} setSigninModal={setSigninModal} /> */}
      {/* <SignupModal
        showModal={showModal}
        setShowModal={setShowModal}
        onClose={() => setShowModal(false)}
      /> */}
    </>
  );
}

export default UniversityHomePage;
